import { NavLink } from "react-router-dom";

const LocationNavBar = () => {
	return (
		<nav>
			<ul>
				<li><NavLink to="/addLocation">Add Location</NavLink></li>
				<li><NavLink to="/editLocation">Edit Location</NavLink></li>
				<li><NavLink to="/deleteLocation">Delete Location</NavLink></li>
				<li><NavLink to="/restoreLocation">Restore Location</NavLink></li>
			</ul>
		</nav>
	)
}

export default LocationNavBar;
